"use strict";

var cov_28kaw8o0tm = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/repository/Repository.context.js";
  var hash = "bdbb6930940f748cf78f348ccbcd748dcb7904d5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/repository/Repository.context.js",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 33
        },
        end: {
          line: 6,
          column: 54
        }
      },
      "1": {
        start: {
          line: 21,
          column: 66
        },
        end: {
          line: 21,
          column: 99
        }
      },
      "2": {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 29,
          column: 4
        }
      },
      "3": {
        start: {
          line: 31,
          column: 18
        },
        end: {
          line: 37,
          column: 3
        }
      },
      "4": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 43,
          column: 4
        }
      },
      "5": {
        start: {
          line: 46,
          column: 0
        },
        end: {
          line: 91,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "RepositoryContextProvider",
        decl: {
          start: {
            line: 8,
            column: 16
          },
          end: {
            line: 8,
            column: 41
          }
        },
        loc: {
          start: {
            line: 20,
            column: 3
          },
          end: {
            line: 44,
            column: 1
          }
        },
        line: 20
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 26,
            column: 12
          },
          end: {
            line: 26,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 12
          },
          end: {
            line: 26,
            column: 19
          }
        }, {
          start: {
            line: 26,
            column: 23
          },
          end: {
            line: 26,
            column: 36
          }
        }],
        line: 26
      },
      "1": {
        loc: {
          start: {
            line: 27,
            column: 20
          },
          end: {
            line: 27,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 27,
            column: 20
          },
          end: {
            line: 27,
            column: 35
          }
        }, {
          start: {
            line: 27,
            column: 39
          },
          end: {
            line: 27,
            column: 60
          }
        }],
        line: 27
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "bdbb6930940f748cf78f348ccbcd748dcb7904d5"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RepositoryContextProvider = RepositoryContextProvider;
exports.RepositoryContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("../..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var RepositoryContext = (cov_28kaw8o0tm.s[0]++, _react.default.createContext());
exports.RepositoryContext = RepositoryContext;

function RepositoryContextProvider(_ref) {
  var full_name = _ref.full_name,
      repositories = _ref.repositories,
      urls = _ref.urls,
      defaultOwner = _ref.defaultOwner,
      defaultQuery = _ref.defaultQuery,
      _config = _ref.config,
      _authentication = _ref.authentication,
      repository = _ref.repository,
      onRepository = _ref.onRepository,
      branch = _ref.branch,
      children = _ref.children;
  cov_28kaw8o0tm.f[0]++;

  var _ref2 = (cov_28kaw8o0tm.s[1]++, (0, _react.useContext)(_.AuthenticationContext)),
      contextAuthentication = _ref2.state,
      contextConfig = _ref2.config;

  var _ref3 = (cov_28kaw8o0tm.s[2]++, (0, _.useRepository)({
    full_name: full_name,
    repositories: repositories,
    urls: urls,
    defaultOwner: defaultOwner,
    defaultQuery: defaultQuery,
    config: (cov_28kaw8o0tm.b[0][0]++, _config) || (cov_28kaw8o0tm.b[0][1]++, contextConfig),
    authentication: (cov_28kaw8o0tm.b[1][0]++, _authentication) || (cov_28kaw8o0tm.b[1][1]++, contextAuthentication),
    repository: repository,
    branch: branch,
    onRepository: onRepository
  })),
      state = _ref3.state,
      actions = _ref3.actions,
      component = _ref3.component,
      components = _ref3.components,
      config = _ref3.config;

  var context = (cov_28kaw8o0tm.s[3]++, {
    state: state,
    actions: actions,
    component: component,
    components: components,
    config: config
  });
  cov_28kaw8o0tm.s[4]++;
  return /*#__PURE__*/_react.default.createElement(RepositoryContext.Provider, {
    value: context
  }, children);
}

;
cov_28kaw8o0tm.s[5]++;
RepositoryContextProvider.propTypes = {
  /** Repository data to render, if url not provided. */
  repository: _propTypes.default.shape({
    id: _propTypes.default.number,
    owner: _propTypes.default.object.isRequired,
    name: _propTypes.default.string.isRequired,
    full_name: _propTypes.default.string.isRequired,
    description: _propTypes.default.string.isRequired,
    html_url: _propTypes.default.string.isRequired,
    website: _propTypes.default.string.isRequired,
    tree_url: _propTypes.default.string,
    avatar_url: _propTypes.default.string,
    branch: _propTypes.default.string
  }),

  /** Function to call when repository is selected. */
  onRepository: _propTypes.default.func.isRequired,

  /** Full name of the repo, `owner/name` */
  full_name: _propTypes.default.string,

  /** Pass a previously returned authentication object to bypass login. */
  authentication: _propTypes.default.shape({
    user: _propTypes.default.object.isRequired,
    token: _propTypes.default.object.isRequired,
    config: _propTypes.default.object.isRequired,
    remember: _propTypes.default.bool
  }),

  /** Urls array to get repository data, if repository data is not provided. */
  urls: _propTypes.default.array,

  /** Repositories data array to render, if urls not provided. */
  repositories: _propTypes.default.array,

  /** Prefill the owner search field. */
  defaultOwner: _propTypes.default.string,

  /** Prefill the query search field. */
  defaultQuery: _propTypes.default.string,

  /** The name of the branch to read/write files */
  branch: _propTypes.default.string,

  /** Configuration to pass through to the Search/Repositories component. */
  config: _propTypes.default.shape({
    /** Configuration required for Search or Repositories if paths are provided as URL. */
    server: _propTypes.default.string
  }),

  /** Children to render inside of Provider */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired
};